import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { OpenClaimRequest } from '../../shared/models/dto/open-claim-request';
import { HomeserveService } from '../../shared/services/homeserve.service';
import { MasterDataService } from '../../shared/services/master-data.service';
import { StorageService } from '../../shared/services/storage.service';
import { DataLayerService } from '../../core/services/dataLayer.service';
import { StepTrackerService } from '../../core/services/stepTracker.service';

@Component({
	selector: 'click-to-call',
	templateUrl: './click-to-call.component.html',
	styleUrls: ['./click-to-call.component.scss'],
	providers: [NgbModalConfig, NgbModal, DataLayerService]
})
export class ClickToCallComponent {
	phoneConfirmed: boolean = false;
	prefixList: string[];
	phoneInput: boolean = false;
	phoneEmptyMsg: string = '';
	savedPhoneNumber: string = '';
	savedPhonePrefix: string = '';
	formGroup: FormGroup = new FormGroup({});
	termAccepted: boolean = false;
	fields: any = [
		{field: "LEIDO_1",value: "N"},
		{field: "CONSENTIMIENTO",value: "N"},
		{field: "LEIDO_2",value: "N"}
	];
	@Input() public motiveC2C: string = '';
	@Input() public submotiveC2C: string = '';

	currentStep: string = "";
	currentEvent: string = '';

	constructor(
		private masterService: MasterDataService,
		private homeserveService: HomeserveService,
		private storageService: StorageService,
		private formBuilder: FormBuilder,
    	private dataLayerService: DataLayerService,	
		private stepTrackerService: StepTrackerService
	) {
		this.initForm();
		this.prefixList = this.masterService.getPhonePrefixList();
		const sessionData: any = this.storageService.get(this.storageService.contactDataKey);
		if (this.homeserveService.getCurrentInsured()) {
			this.setPhoneNumber(sessionData);
			this.setPhonePrefix(sessionData);
		} else if (sessionData?.contactData?.contacts?.length > 0) {
			this.savedPhoneNumber = sessionData?.contactData?.contacts[0].phone;
			this.formGroup.get('phoneNumber')?.setValue(sessionData?.contactData?.contacts[0].phone);
			this.savedPhonePrefix = sessionData?.contactData?.contacts[0].prefixPhone;
			this.formGroup.get('phonePrefix')?.setValue(sessionData?.contactData?.contacts[0].prefixPhone);
		}
		this.fields = this.storageService.get('terms') ? this.storageService.get('terms') : this.fields;
	}

	ngOnInit(): void {

		const currentEventName = this.stepTrackerService.getCurrentEventName()
		this.dataLayerService.addDataToDataLayer({
			'event': 'modulo_hogar_c2c',
			'componentStep' :`${currentEventName}`,
			'eventData_origin':`${this.motiveC2C}`
		});
		const currentStep = this.stepTrackerService.getCurrentStep();	
		this.dataLayerService.addDataToDataLayer({
			'event': 'uaevent',
			'eventCategory': 'Funnel Hogar Siniestros',
			'eventAction': 'modulo_hogar_C2C',
			'eventLabel': `Step${currentStep}_${this.motiveC2C}`
		  });
	
	}

	initForm() {
		this.formGroup = this.formBuilder.group({
			phoneNumber: ['', [Validators.required]],
			phonePrefix: ['+34', [Validators.required]]
		});
	}

	setPhoneNumber(sessionData: any) {
		if (sessionData?.contactData?.contacts?.length > 0) {
			this.savedPhoneNumber = sessionData?.contactData?.contacts[0].phone;
			this.formGroup.get('phoneNumber')?.setValue(sessionData?.contactData?.contacts[0].phone);
		} 
		else if (this.homeserveService.getCurrentInsured()?.phoneList !== undefined) {
			this.savedPhoneNumber = this.homeserveService.getCurrentInsured()?.phoneList[0]?.numPhone ?? '';
			this.formGroup
				.get('phoneNumber')
				?.setValue(this.homeserveService.getCurrentInsured()?.phoneList[0]?.numPhone ?? '');
		} else {
			this.savedPhoneNumber = '';
			this.formGroup.get('phoneNumber')?.setValue('');
		}
	}

	setPhonePrefix(sessionData: any) {
		if (sessionData?.contactData?.contacts?.length > 0) {
			this.savedPhonePrefix = sessionData?.contactData?.contacts[0].prefixPhone;
			this.formGroup.get('phonePrefix')?.setValue(sessionData?.contactData?.contacts[0].prefixPhone);
		} else if (this.homeserveService.getCurrentInsured()?.phoneList !== undefined) {
			this.savedPhonePrefix = `+${this.homeserveService.getCurrentInsured()?.phoneList[0]?.prefixPhone ?? 34}`;
			this.formGroup
				.get('phonePrefix')
				?.setValue(`+${this.homeserveService.getCurrentInsured()?.phoneList[0]?.prefixPhone ?? 34}`);
		} else {
			this.savedPhonePrefix = '';
			this.formGroup.get('phonePrefix')?.setValue('+34');
		}
	}

	acceptTerms() {
		this.termAccepted = !this.termAccepted;
	}
	disclaimerData(){
		this.fields[2].value = 'S';
		this.storageService.save('terms', this.fields);
		this.homeserveService.setOthersListInfo(this.fields);
	}

	callConfirmPhone() {
		this.disclaimerData();
		const form = this.formGroup;
		const openClaimReq: OpenClaimRequest = this.homeserveService.getOpenClaimRequest();
		openClaimReq.phoneC2CInfo = {
			numPhone: this.formGroup.get('phoneNumber')?.value ?? '',
			prefixPhone: this.formGroup.get('phonePrefix')?.value ?? '',
			typePhone: '1'
		};
		openClaimReq.typeCall = '2';
		// si ha fallado en decisionTree (entiendo que es por claimType 16, 17 y 18) rellenar motive C2C con 00016, 00017 y 00018 respectivamente
		// si falla por openClaim (entiendo que es por claimType 4) rellenar motive con error del openClaim
		openClaimReq.motivec2c = this.motiveC2C ?? 'C2C';
		openClaimReq.submotivec2c = this.submotiveC2C;

		this.homeserveService.openClaim(openClaimReq).subscribe((result) => {
			this.phoneConfirmed = true;
		});
		const currentEventName = this.stepTrackerService.getCurrentEventName()
		this.dataLayerService.addDataToDataLayer({
			'event': 'modulo_hogar_c2c_confirmed',
			'componentStep' :`${currentEventName}`,
			'eventData_origin':`${this.motiveC2C}`
		});
		const currentStep = this.stepTrackerService.getCurrentStep();	
		this.dataLayerService.addDataToDataLayer({
			'event': 'uaevent',
			'eventCategory': 'Funnel Hogar Siniestros',
			'eventAction': 'modulo_hogar_c2c_confirmed',
			'eventLabel': `Step${currentStep}_${this.motiveC2C}`
		  });
	
	}

	onSelectPrefix(prefix: string) {
		this.formGroup.get('phonePrefix')?.setValue(prefix);
	}

	showPhoneInput(event: any) {
		this.phoneInput = event.target.checked;
		if (!this.phoneInput) {
			this.formGroup.get('phonePrefix')?.setValue(this.savedPhonePrefix);
			this.formGroup.get('phoneNumber')?.setValue(this.savedPhoneNumber);
		}
	}
}
